export default __webpack_public_path__ + "static/media/game-trailer.8bfedb06.mp4";